export default "__VITE_ASSET__CiRPia1O__"